export enum CustomFieldType {
    String = 'string',
    Boolean = 'boolean',
    Number = 'number',
    Object = 'object',
    Null = 'null'
}

export type CustomField = {
    name: string;
    type: CustomFieldType | CustomFieldType[];
    nullable?: boolean;
    title?: string;
    maxLength?: number;
    minLength?: number;
    minimum?: number;
    maximum?: number;
    enum?: string[];
    required?: boolean;
    format?: string;
    pattern?: string;
    children?: CustomField[];
}